<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer v-if="!isSubModule" />
    <!-- Delete:右侧目录组件 -->
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  computed: {
    isSubModule() {
      const subModuleRoutes = ['/ai', '/data-service', '/tech-consult', '/llm', '/data-platform', '/lowcode'];
      return subModuleRoutes.some(route => this.$route.path === route);
    }
  },
  mounted() {
    // 添加全局滚动动画效果
    this.addScrollAnimation();
  },
  methods: {
    addScrollAnimation() {
      // 这里可以添加滚动监听来触发动画，但为了性能考虑，我们已经在各组件中实现了入场动画
      // 如果需要更复杂的滚动动画，可以在这里实现
    },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const offsetTop = element.offsetTop - 80; // 考虑固定头部的高度
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    },
  },
  beforeUnmount() {
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */
}

:root {
  --primary-blue: #1a3a8f;
  --secondary-blue: #2d4fa9;
  --accent-gold: #d4af37;
  --light-blue: #e8f0fe;
  --dark-blue: #0a1f5c;
  --text-dark: #333333;
  --text-light: #666666;
  --white: #ffffff;
  --gray-bg: #f8f9fa;
}

body {
  font-family: 'Microsoft YaHei', 'Segoe UI', Arial, sans-serif;
  line-height: 1.6;
  color: var(--text-dark);
  background-color: var(--white);
  overflow-x: hidden;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section {
  padding: 80px 0;
  position: relative;
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  color: var(--primary-blue);
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 15px;
  animation: fadeInDown 0.8s ease-out;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background-color: var(--accent-gold);
  border-radius: 2px;
  animation: glowPulse 2s infinite alternate;
}

@keyframes glowPulse {
  from {
    box-shadow: 0 0 5px rgba(212, 175, 55, 0.3);
  }
  to {
    box-shadow: 0 0 15px rgba(212, 175, 55, 0.6);
  }
}

.section-subtitle {
  text-align: center;
  font-size: 1.2rem;
  color: var(--text-light);
  max-width: 800px;
  margin: 0 auto 50px;
  animation: fadeIn 0.8s ease-out;
  animation-delay: 0.2s;
  animation-fill-mode: backwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.btn {
  display: inline-block;
  padding: 12px 30px;
  background-color: var(--primary-blue);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.btn:hover {
  background-color: var(--secondary-blue);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 58, 143, 0.2);
}

.btn:hover::before {
  left: 100%;
}

.btn-accent {
  background-color: var(--accent-gold);
  color: var(--dark-blue);
}

.btn-accent:hover {
  background-color: #e6c158;
}

/* Delete:右侧目录样式 */
/* Delete:.page-toc { */
/* Delete:  position: fixed; */
/* Delete:  right: -60px; /\* 圆心在浏览器边界外 *\/ */
/* Delete:  top: 50%; */
/* Delete:  transform: translateY(-50%); */
/* Delete:  z-index: 100; */
/* Delete:  display: flex; */
/* Delete:  width: 200px; */
/* Delete:  height: 200px; */
/* Delete:  padding: 10px; */
/* Delete:  opacity: 0; */
/* Delete:  animation: fadeInToc 0.8s ease-out forwards; */
/* Delete:  transition: transform 0.2s ease; */
/* Delete:  border-radius: 50%; */
/* Delete:} */

/* Delete:@keyframes fadeInToc { */
/* Delete:  to { */
/* Delete:    opacity: 1; */
/* Delete:  } */
/* Delete:} */

/* Delete:.toc-item { */
/* Delete:  position: absolute; */
/* Delete:  top: 50%; */
/* Delete:  left: 50%; */
/* Delete:  transform-origin: -80px 0; */
/* Delete:  padding: 8px 16px; */
/* Delete:  background: rgba(120, 120, 120, 0.15); /\* 使用灰色系背景 *\/ */
/* Delete:  border-radius: 20px; */
/* Delete:  cursor: pointer; */
/* Delete:  transition: all 0.3s ease; */
/* Delete:  font-size: 14px; */
/* Delete:  font-weight: 500; */
/* Delete:  color: #444444; /\* 灰黑色字体 *\/ */
/* Delete:  backdrop-filter: blur(10px); */
/* Delete:  border: 1px solid rgba(100, 100, 100, 0.2); /\* 灰色边框 *\/ */
/* Delete:  box-shadow:  */
/* Delete:    0 2px 10px rgba(0, 0, 0, 0.1), */
/* Delete:    inset 0 0 5px rgba(150, 150, 150, 0.1); */
/* Delete:  text-shadow: 0 0 4px rgba(100, 100, 100, 0.3); */
/* Delete:  white-space: nowrap; */
/* Delete:} */

/* Delete:.toc-item:hover { */
/* Delete:  background: rgba(100, 100, 100, 0.25); */
/* Delete:  color: #333333; */
/* Delete:  border-color: rgba(80, 80, 80, 0.3); */
/* Delete:  box-shadow:  */
/* Delete:    0 4px 15px rgba(0, 0, 0, 0.2), */
/* Delete:    inset 0 0 8px rgba(180, 180, 180, 0.1); */
/* Delete:} */

/* Delete:.toc-item.active { */
/* Delete:  background: rgba(90, 90, 90, 0.3); */
/* Delete:  color: #222222; */
/* Delete:  border-color: rgba(70, 70, 70, 0.4); */
/* Delete:  box-shadow:  */
/* Delete:    0 6px 20px rgba(0, 0, 0, 0.25), */
/* Delete:    inset 0 0 10px rgba(200, 200, 200, 0.15); */
/* Delete:  text-shadow: 0 0 6px rgba(100, 100, 100, 0.5); */
/* Delete:} */

/* Delete:.toc-indicator { */
/* Delete:  position: absolute; */
/* Delete:  right: -8px; */
/* Delete:  top: 50%; */
/* Delete:  transform: translateY(-50%); */
/* Delete:  width: 12px; */
/* Delete:  height: 12px; */
/* Delete:  background: radial-gradient(circle, #888888, #666666); /\* 灰色指示器 *\/ */
/* Delete:  border-radius: 50%; */
/* Delete:  box-shadow:  */
/* Delete:    0 0 8px #888888, */
/* Delete:    0 0 15px rgba(136, 136, 136, 0.6); */
/* Delete:  animation: pulseIndicator 1.8s infinite alternate; */
/* Delete:} */

/* Delete:@keyframes pulseIndicator { */
/* Delete:  0% {  */
/* Delete:    transform: translateY(-50%) scale(1);  */
/* Delete:    box-shadow: 0 0 8px #888888, 0 0 15px rgba(136, 136, 136, 0.6); */
/* Delete:  } */
/* Delete:  100% {  */
/* Delete:    transform: translateY(-50%) scale(1.2);  */
/* Delete:    box-shadow: 0 0 12px #888888, 0 0 20px rgba(136, 136, 136, 0.8); */
/* Delete:  } */
/* Delete:} */

/* Delete:为每个目录项设置不同的旋转角度 */
/* Delete:.toc-item:nth-child(1) { transform: rotate(0deg) translateX(80px) rotate(0deg); } */
/* Delete:.toc-item:nth-child(2) { transform: rotate(60deg) translateX(80px) rotate(-60deg); } */
/* Delete:.toc-item:nth-child(3) { transform: rotate(120deg) translateX(80px) rotate(-120deg); } */
/* Delete:.toc-item:nth-child(4) { transform: rotate(180deg) translateX(80px) rotate(-180deg); } */
/* Delete:.toc-item:nth-child(5) { transform: rotate(240deg) translateX(80px) rotate(-240deg); } */
/* Delete:.toc-item:nth-child(6) { transform: rotate(300deg) translateX(80px) rotate(-300deg); } */

@media (max-width: 1024px) {
  /* Delete:.page-toc { */
  /* Delete:  right: -50px; */
  /* Delete:  width: 160px; */
  /* Delete:  height: 160px; */
  /* Delete:} */
  
  /* Delete:.toc-item { */
  /* Delete:  padding: 6px 12px; */
  /* Delete:  font-size: 12px; */
  /* Delete:  border-radius: 16px; */
  /* Delete:} */
  
  /* Delete:.toc-item:nth-child(1) { transform: rotate(0deg) translateX(60px) rotate(0deg); } */
  /* Delete:.toc-item:nth-child(2) { transform: rotate(72deg) translateX(60px) rotate(-72deg); } */
  /* Delete:.toc-item:nth-child(3) { transform: rotate(144deg) translateX(60px) rotate(-144deg); } */
  /* Delete:.toc-item:nth-child(4) { transform: rotate(216deg) translateX(60px) rotate(-216deg); } */
  /* Delete:.toc-item:nth-child(5) { transform: rotate(288deg) translateX(60px) rotate(-288deg); } */
}

@media (max-width: 768px) {
  /* Delete:.page-toc { */
  /* Delete:  display: none !important; */
  /* Delete:} */
  
  .section {
    padding: 50px 0;
  }
  
  .section-title {
    font-size: 2rem;
  }
}
</style>

